import { Meta, Title } from '@angular/platform-browser';
import { Injectable, inject } from '@angular/core';

export const FALLBACK_TITLE = 'Boels Rental';
@Injectable({
  providedIn: 'root',
})
export class MetaDataService {
  private title = inject(Title);
  private meta = inject(Meta);

  setTitle(title: string): void {
    this.title.setTitle(title);
  }

  setMetaDescription(description?: string): void {
    if (!description) {
      this.meta.removeTag("name='description'");
      return;
    }

    this.meta.updateTag({ name: 'description', content: description });
  }
}
